export default __webpack_public_path__ + "static/media/icon-heart.404db06e.png";